import { useApiClient } from '../client'

export const POS_TRANSACTION_LAST_RECEIPT = '/core/v2/business_api/me/businesses/{businessId}/pos/transactions/{transactionId}/last_receipt'

import type { LastReceiptResponse } from '@/api/types/pos-receipt'

export function getLastReceipt (businessId, transactionId) {
  const apiClient = useApiClient()

  return apiClient.get<LastReceiptResponse>({
    url: POS_TRANSACTION_LAST_RECEIPT,
    urlParams: {
      businessId,
      transactionId,
    },
  })
}
